export * from './crm-vehicle-model-create.endpoint';
export * from './crm-vehicle-model-delete.endpoint';
export * from './crm-vehicle-model-find.endpoint';
export * from './crm-vehicle-model-get-by-id.endpoint';
export * from './crm-vehicle-model-patch.endpoint';

export * from './crm-vehicle-model-image-add.endpoint';
export * from './crm-vehicle-model-image-delete.endpoint';
